import { render, staticRenderFns } from "./TaskSelect.vue?vue&type=template&id=4c6e8a81&"
import script from "./TaskSelect.vue?vue&type=script&lang=js&"
export * from "./TaskSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports